import * as _ from "lodash";
import {
  LIB_PREFIX, ContentTypes
} from "../../TypesAndIdentifiers";
import ActivityPath from "./ActivityPaths";
import BaseConfig from "../utils/BaseConfig";

export default class ActivityConfig extends BaseConfig {
  public readonly paths = new ActivityPath(this.activityProps.type);
  public contentType = ContentTypes.ACTIVITY;

  constructor(public readonly activityProps: any) {
    super();
    this.contentTypeID = activityProps.type;
  }
}
